export const occupationPartTime = 'Z';
export const occupationSelfEmployed = 'S';
export const occupationEmployed = 'E';
export const occupationUnemployed = 'U';